import { render } from "./UserEditTableTab.vue?vue&type=template&id=5fc77872&scoped=true&ts=true"
import script from "./UserEditTableTab.vue?vue&type=script&lang=ts"
export * from "./UserEditTableTab.vue?vue&type=script&lang=ts"

import "./UserEditTableTab.vue?vue&type=style&index=0&id=5fc77872&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc77872"]])

export default __exports__